import { render, staticRenderFns } from "./SignupAuthentication.vue?vue&type=template&id=781434d8&scoped=true"
import script from "./SignupAuthentication.vue?vue&type=script&lang=js"
export * from "./SignupAuthentication.vue?vue&type=script&lang=js"
import style0 from "./SignupAuthentication.vue?vue&type=style&index=0&id=781434d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781434d8",
  null
  
)

export default component.exports